module.exports = __webpack_public_path__ + "static/images/styles/images/landing/landing-award-small.RU.1a08ae0e.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/landing/landing-award-small.RU.png
// module id = 3651
// module chunks = 11